export default __webpack_public_path__ + "static/media/aavev2.437c02f0.svg";